import { campaignMetrics, ChartDataResponse, MetricInfo, MetricLabels } from "@api/common";
import { AppState, currentReportCampaign } from "@store";
import cn from "classnames";
import { FetchingState } from "rd-redux-http";
import * as React from "react";
import { connect } from "react-redux";
import "./DynamicFunnelReports.css";
import { ReportLabel } from "./ReportLabel";
import { formatNumber } from "@common";

interface FunnelChartProps {
    metrics: MetricInfo[];
    data: number[];
}

function DynamicFunnelReportsComponent(props: FunnelChartProps) {
    const { data, metrics } = props;
    return (
        <div className="FunnelReports">
            <div className="FunnelReports__head">
                <ReportLabel title={"Funnel Performance"} />
            </div>
            <div className="FunnelReports__content">
                <div className="FunnelReports__row">
                    {data &&
                        data.map((val: number, index: number) => {
                            const { isRate, color } = metrics[index];
                            const title = MetricLabels.metricSwitcher(metrics[index]);

                            return !isRate ? (
                                <CategoryItem
                                    value={String(val)}
                                    subtitle={title}
                                    statusDotTheme={color}
                                    cn={"FunnelReports__item"}
                                    key={`row-item-${index}`}
                                />
                            ) : (
                                <PercentValueLine
                                    value={String((val * 100).toFixed(2))}
                                    cn={"FunnelReports__item"}
                                    key={`row-item-${index}`}
                                />
                            );
                        })}
                </div>
            </div>
        </div>
    );
}

interface CategoryItemProps {
    subtitle: string;
    value: string;
    statusDotTheme: string;
    cn?: string;
}

const CategoryItem = (props: CategoryItemProps) => (
    <div className={cn("CategoryItem", props.cn)}>
        <span className={cn("CategoryItem__statusDot")} style={{ backgroundColor: props.statusDotTheme }} />
        <span className="CategoryItem__valueText">
            {formatNumber(props.value)}
            <span className="CategoryItem__subtitle">{props.subtitle}</span>
        </span>
    </div>
);

interface PercentValueLineProps {
    value: string;
    cn?: string;
}

const PercentValueLine = (props: PercentValueLineProps) => (
    <div className={cn("Line", props.cn)}>
        <span className="Line__value">{`${props.value}%`}</span>
        <span className="Line__decorLine" />
    </div>
);

export const DynamicFunnelReports = connect<FunnelChartProps>((state: AppState) => {
    const data: ChartDataResponse = FetchingState.getDataOrDefault(state.reports.chartData.overallData, {
        metrics: [],
        dimensions: []
    });

    const campaign = currentReportCampaign(state);

    const metrics = campaign && campaignMetrics(campaign.unit);

    const preparedData: number[] =
        metrics &&
        metrics.map((metricItem: MetricInfo) => {
            const metric = data.metrics.find(m => m.metric === metricItem.metric);
            if (metric && metric.data && metric.data.length) {
                return metric.data[0]["metric-value"];
            }

            return 0;
        });

    return { data: preparedData, metrics };
})(DynamicFunnelReportsComponent);
